import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '@costar/theme-ui';

var tooltips = _defineProperty({}, THEME_UI_DEFAULT_KEY, {
  bg: 'white',
  color: 'text',
  borderRadius: 0,
  p: 'lg',
  maxWidth: 350,
  minHeight: '32px',
  elevation: 400
});

export { tooltips };
//# sourceMappingURL=tooltips.esm.js.map
